import { render, staticRenderFns } from "./ComplieLeftContentIconMenu.vue?vue&type=template&id=072fc3e3&scoped=true"
import script from "./ComplieLeftContentIconMenu.vue?vue&type=script&lang=js"
export * from "./ComplieLeftContentIconMenu.vue?vue&type=script&lang=js"
import style0 from "./ComplieLeftContentIconMenu.vue?vue&type=style&index=0&id=072fc3e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072fc3e3",
  null
  
)

export default component.exports